import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {partner} from "../../../models/partner";
import {scrollTo} from "../../../service/ToolsService";

type PartnerListProp = {
  partners: partner[],
  loading?: boolean,
  refresh: () => void,
}

export const PartnerList = ({partners, loading, refresh}: PartnerListProp) => {
  const [del, setDel] = useState(undefined as undefined | partner);

  const deletePartner = async (partner: partner) => {
    await ApiService.delete(`/partner/${partner.partnerId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w80px">Description</th>
          <th className="text-center w80px">Photo</th>
          <th className="text-center w80px">Adresse</th>
          <th className="text-center w80px">Lien</th>
          <th className="text-center w80px">Visible</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={8} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && partners.map((p: partner, i: number) => (
          <tr key={i} className="align-middle">
            <td>{p.label}</td>
            <td className="text-center">{p.description && (<i className="fa-regular fa-file-lines"/>)}</td>
            <td className="text-center">{p.photo && (<i className="fa-regular fa-image"/>)}</td>
            <td className="text-center">{p.adress && (<i className="fa-solid fa-location-dot"/>)}</td>
            <td className="text-center">{p.link && (<i className="fa-solid fa-at"/>)}</td>
            <td className="text-center">{p.enabled && (<i className="fa-solid fa-eye"/>)}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(p.updatedAt ?? p.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/partner/edit/${p.partnerId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(p)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deletePartner(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
